import { mixin } from 'vue-clickaway';

//

var script = {
  name: "VSelect",
  mixins: [mixin],
  props: {
    addClass:{
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledProp: {
      type: String,
      default: "disabled"
    },
    defaultTitle: {
      type: String,
      default: "Nothing selected"
    },
    searchNotFound: {
      type: String,
      default: "No results matched"
    },
    searchPlaceholder: {
      type: String,
      default: "Search"
    },
    options: {
      type: Array,
      default: function () { return []; }
    },
    searchable: {
      type: Boolean,
      default: false
    },
    showDefaultOption: {
      type: Boolean,
      default: false
    },
    textProp: {
      type: String,
      default: "text"
    },
    value: {
      type: [Object, String, Number],
      default: null
    },
    valueProp: {
      type: String,
      default: "value"
    },
    valuePlaceHolder: {
      type: String,
      default: "Nothing is Selected"
    },
  },
  data: function data() {
    return {
      show: false,
      selectedValue: null,
      searchValue: "",
      typeAheadPointer: -1
    };
  },
  computed: {
    title: function title() {
      return this.selectedValue
        ? this.getOptionLabel(this.selectedValue)
        : this.defaultTitle;
    },
    filteredOptions: function filteredOptions() {
      var this$1 = this;

      if (this.searchable && this.searchValue.length > 0) {
        return this.options.filter(function (item) {
          if (typeof item === "object") {
            return (
              item[this$1.textProp]
                .toLowerCase()
                .indexOf(this$1.searchValue.toLowerCase()) !== -1
            );
          } else {
            return (
              item.toLowerCase().indexOf(this$1.searchValue.toLowerCase()) !== -1
            );
          }
        });
      }
      return this.options;
    },
    reversedOptions: function reversedOptions() {
      return [].concat( this.filteredOptions ).reverse();
    },
    lastOptionIndex: function lastOptionIndex() {
      return this.filteredOptions.length - 1;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(newVal) {
        var this$1 = this;

        var index = this.options.findIndex(function (op) { return this$1.isEqualOption(op, newVal); }
        );
        this.onSelect(newVal, index);
      }
    }
  },
  methods: {
    onSelect: function onSelect(option, index) {
      if (option && !option[this.disabledProp]) {
        this.selectedValue = option;
        this.typeAheadPointer = index;
        this.hideDropdown();
        for(var i=0; i<this.options.length; i++){
          if(option.value==this.options[i].value){
              option=this.options[i];
          }
        }
        if(option.value==null){
          this.selectedValue = null;
        }
        else {
          this.$emit("input", option, option.valueProp, index);
        }
      } else if (option === null) {
        this.selectedValue = null;
      }
    },
    onEscape: function onEscape() {
      this.hideDropdown();
    },
    typeAheadUp: function typeAheadUp() {
      var this$1 = this;

      if (!this.show) {
        this.show = true;
      }
      if (this.typeAheadPointer > 0) {
        var nextPointer = this.typeAheadPointer - 1;
        var option = this.filteredOptions[nextPointer];
        var isDisabled = option ? option[this.disabledProp] || false : false;
        if (!isDisabled) {
          this.typeAheadPointer--;
        } else {
          this.typeAheadPointer--;
          this.typeAheadUp();
        }
      } else {
        var nextEnabledOption = this.reversedOptions.findIndex(
          function (o) { return o[this$1.disabledProp] !== true; }
        );
        this.typeAheadPointer = this.lastOptionIndex - nextEnabledOption;
      }
    },
    typeAheadDown: function typeAheadDown() {
      var this$1 = this;

      if (!this.show) {
        this.show = true;
      }
      if (this.typeAheadPointer < this.lastOptionIndex) {
        var nextPointer = this.typeAheadPointer + 1;
        var option = this.filteredOptions[nextPointer];
        var isDisabled = option ? option[this.disabledProp] || false : false;
        if (!isDisabled) {
          this.typeAheadPointer++;
        } else {
          this.typeAheadPointer++;
          this.typeAheadDown();
        }
      } else {
        var nextEnabledOption = this.filteredOptions.findIndex(
          function (o) { return o[this$1.disabledProp] !== true; }
        );
        this.typeAheadPointer = nextEnabledOption;
      }
    },
    typeAheadSelect: function typeAheadSelect() {
      if (this.filteredOptions[this.typeAheadPointer]) {
        this.onSelect(
          this.filteredOptions[this.typeAheadPointer],
          this.typeAheadPointer
        );
      }
    },
    hideDropdown: function hideDropdown() {
      this.show = false;
      this.searchValue = "";
    },
    getOptionLabel: function getOptionLabel(option) {
      if (typeof option === "object") {
        return option[this.textProp];
      }
      return option;
    },
    isSelectedOption: function isSelectedOption(option, index) {
      if (this.typeAheadPointer === -1 && this.selectedValue) {
        return this.isEqualOption(option, this.selectedValue);
      }
      return this.typeAheadPointer === index;
    },
    isEqualOption: function isEqualOption(a, b) {
      if (a && b && typeof a === "object" && typeof b === "object") {
        return (
          a[this.textProp] === b[this.textProp] &&
          a[this.valueProp] === b[this.valueProp]
        );
      }
      return a === b;
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.show = !this.show;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.hideDropdown,
          expression: "hideDropdown"
        }
      ],
      staticClass: "v-select",
      class: { disabled: _vm.disabled, addClass: _vm.addClass },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.onEscape($event)
        },
        keydown: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault();
            return _vm.typeAheadUp($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            $event.preventDefault();
            return _vm.typeAheadDown($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault();
            return _vm.typeAheadSelect($event)
          }
        ]
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "v-select-toggle",
          attrs: { type: "button" },
          on: { click: _vm.toggle }
        },
        [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.title) } }),
          _vm._v(" "),
          _c("div", { staticClass: "arrow-down" })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show"
            }
          ],
          staticClass: "v-dropdown-container"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.searchable,
                  expression: "searchable"
                }
              ],
              staticClass: "v-bs-searchbox"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchValue,
                    expression: "searchValue"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: _vm.searchPlaceholder,
                  type: "text",
                  autofocus: ""
                },
                domProps: { value: _vm.searchValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchValue = $event.target.value;
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            [
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.searchable && _vm.filteredOptions.length === 0,
                      expression: "searchable && filteredOptions.length === 0"
                    }
                  ],
                  staticClass: "v-dropdown-item"
                },
                [
                  _vm._v(
                    _vm._s(_vm.searchNotFound) +
                      ' "' +
                      _vm._s(_vm.searchValue) +
                      '"'
                  )
                ]
              ),
              _vm._v(" "),
              _vm.showDefaultOption
                ? _c(
                    "li",
                    { staticClass: "v-dropdown-item disabled default-option" },
                    [_vm._v(_vm._s(_vm.defaultTitle))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filteredOptions, function(option, index) {
                return _c(
                  "li",
                  {
                    key: "v-select-" + index,
                    staticClass: "v-dropdown-item",
                    class: {
                      selected: _vm.isSelectedOption(option, index),
                      disabled: option[_vm.disabledProp]
                    },
                    on: {
                      click: function($event) {
                        return _vm.onSelect(option, index)
                      }
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.getOptionLabel(option))
                      }
                    })
                  ]
                )
              })
            ],
            2
          )
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-54036eab_0", { source: "*[data-v-54036eab] {\n  box-sizing: border-box;\n}\ninput[data-v-54036eab] {\n  width: 100%;\n}\nul[data-v-54036eab] {\n  font-size: 12px;\n  color: #424242;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  padding: 0px;\n  margin: 2px 0px 0px 0px;\n}\n.v-select[data-v-54036eab] {\n  position: relative;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n}\n.v-select.disabled[data-v-54036eab] {\n  cursor: not-allowed;\n}\n.v-select.disabled .v-select-toggle[data-v-54036eab] {\n  background-color: #fff;\n  border-color: #f8f9fa;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n.v-select.disabled .v-select-toggle[data-v-54036eab]:focus {\n  outline: 0 !important;\n}\n.v-select-toggle[data-v-54036eab] {\n  display: flex;\n  justify-content: space-between;\n  user-select: none;\n  padding: 0.375rem 0.75rem;\n  color: #212529;\n  background-color: #fff;\n  border-color: #d3d9df;\n  width: 100%;\n  text-align: right;\n  white-space: nowrap;\n  border: 1px solid #ccc;\n  padding: 0.375rem 0.75rem;\n  font-size: 12px;\n  font-family: inherit, sans-serif;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: background-color, border-color, box-shadow, 0.15s ease-in-out;\n  cursor: pointer;\n}\n.v-select-toggle[data-v-54036eab]:hover {\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n}\n.arrow-down[data-v-54036eab] {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  margin-top: 7px;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.v-dropdown-container[data-v-54036eab] {\n  position: absolute;\n  width: 100%;\n  background: red;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n}\n.v-dropdown-item[data-v-54036eab] {\n  text-decoration: none;\n  line-height: 25px;\n  padding: 0.5rem 1.25rem;\n  user-select: none;\n}\n.v-dropdown-item[data-v-54036eab]:hover:not(.default-option) {\n  background-color: #f8f9fa;\n}\n.v-dropdown-item.disabled[data-v-54036eab] {\n  color: #9a9b9b;\n}\n.v-dropdown-item.selected[data-v-54036eab] {\n  background-color: #007bff;\n  color: #fff;\n}\n.v-dropdown-item.selected[data-v-54036eab]:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n.v-dropdown-item.disabled[data-v-54036eab] {\n  cursor: not-allowed;\n}\n.v-dropdown-item.disabled[data-v-54036eab]:hover {\n  background-color: #fff;\n}\n.v-bs-searchbox[data-v-54036eab] {\n  padding: 4px 8px;\n}\n.v-bs-searchbox .form-control[data-v-54036eab] {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n/*# sourceMappingURL=vue-select-picker-bootstrap.vue.map */", map: {"version":3,"sources":["D:\\vue-select-picker\\src\\vue-select-picker-bootstrap.vue","vue-select-picker-bootstrap.vue"],"names":[],"mappings":"AAyQA;EACA,sBAAA;ACxQA;AD2QA;EACA,WAAA;ACxQA;AD2QA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;EACA,uBAAA;ACxQA;AD2QA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;ACxQA;AD2QA;EACA,mBAAA;ACzQA;AD2QA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;ACzQA;AD4QA;EACA,qBAAA;AC1QA;ADgRA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,yEAAA;EACA,eAAA;AC7QA;AD+QA;EACA,yBAAA;EACA,qBAAA;AC7QA;ADiRA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AC9QA;ADiRA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,qCAAA;EACA,aAAA;AC9QA;ADiRA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;AC9QA;ADgRA;EACA,yBAAA;AC9QA;ADiRA;EACA,cAAA;AC/QA;ADkRA;EACA,yBAAA;EACA,WAAA;AChRA;ADkRA;EACA,yBAAA;EACA,WAAA;AChRA;ADoRA;EACA,mBAAA;AClRA;ADoRA;EACA,sBAAA;AClRA;ADuRA;EACA,gBAAA;ACpRA;ADsRA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,wEAAA;ACpRA;;AAEA,0DAA0D","file":"vue-select-picker-bootstrap.vue","sourcesContent":["<template>\n  <div\n    v-on-clickaway=\"hideDropdown\"\n    @keyup.esc=\"onEscape\"\n    @keydown.up.prevent=\"typeAheadUp\"\n    @keydown.down.prevent=\"typeAheadDown\"\n    @keydown.enter.prevent=\"typeAheadSelect\"\n    class=\"v-select\"\n    :class=\"{'disabled': disabled, addClass}\">\n    <button @click=\"toggle\" type=\"button\" class=\"v-select-toggle\">\n      <div v-html=\"title\"></div>\n      <div class=\"arrow-down\"></div>\n    </button>\n    <div v-show=\"show\" class=\"v-dropdown-container\">\n      <div v-show=\"searchable\" class=\"v-bs-searchbox\">\n        <input\n          :placeholder=\"searchPlaceholder\"\n          class=\"form-control\"\n          type=\"text\"\n          v-model=\"searchValue\"\n          autofocus\n        >\n      </div>\n      <ul>\n        <li\n          v-show=\"searchable && filteredOptions.length === 0\"\n          class=\"v-dropdown-item\"\n        >{{ searchNotFound }} \"{{ searchValue }}\"</li>\n        <li\n          v-if=\"showDefaultOption\"\n          class=\"v-dropdown-item disabled default-option\"\n        >{{ defaultTitle }}</li>\n        <li\n          v-for=\"(option, index) in filteredOptions\"\n          :key=\"`v-select-${index}`\"\n          class=\"v-dropdown-item\"\n          :class=\"{'selected' : isSelectedOption(option, index), 'disabled': option[disabledProp]}\"\n          @click=\"onSelect(option, index)\"\n        >\n          <span v-html=\"getOptionLabel(option)\"></span>\n        </li>\n      </ul>\n    </div>\n  </div>\n</template>\n\n<script>\nimport { mixin as clickaway } from \"vue-clickaway\";\n\nexport default {\n  name: \"VSelect\",\n  mixins: [clickaway],\n  props: {\n    addClass:{\n      type: String,\n      default: \"\"\n    },\n    disabled: {\n      type: Boolean,\n      default: false\n    },\n    disabledProp: {\n      type: String,\n      default: \"disabled\"\n    },\n    defaultTitle: {\n      type: String,\n      default: \"Nothing selected\"\n    },\n    searchNotFound: {\n      type: String,\n      default: \"No results matched\"\n    },\n    searchPlaceholder: {\n      type: String,\n      default: \"Search\"\n    },\n    options: {\n      type: Array,\n      default: () => []\n    },\n    searchable: {\n      type: Boolean,\n      default: false\n    },\n    showDefaultOption: {\n      type: Boolean,\n      default: false\n    },\n    textProp: {\n      type: String,\n      default: \"text\"\n    },\n    value: {\n      type: [Object, String, Number],\n      default: null\n    },\n    valueProp: {\n      type: String,\n      default: \"value\"\n    },\n    valuePlaceHolder: {\n      type: String,\n      default: \"Nothing is Selected\"\n    },\n  },\n  data() {\n    return {\n      show: false,\n      selectedValue: null,\n      searchValue: \"\",\n      typeAheadPointer: -1\n    };\n  },\n  computed: {\n    title() {\n      return this.selectedValue\n        ? this.getOptionLabel(this.selectedValue)\n        : this.defaultTitle;\n    },\n    filteredOptions() {\n      if (this.searchable && this.searchValue.length > 0) {\n        return this.options.filter(item => {\n          if (typeof item === \"object\") {\n            return (\n              item[this.textProp]\n                .toLowerCase()\n                .indexOf(this.searchValue.toLowerCase()) !== -1\n            );\n          } else {\n            return (\n              item.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1\n            );\n          }\n        });\n      }\n      return this.options;\n    },\n    reversedOptions() {\n      return [...this.filteredOptions].reverse();\n    },\n    lastOptionIndex() {\n      return this.filteredOptions.length - 1;\n    }\n  },\n  watch: {\n    value: {\n      immediate: true,\n      handler(newVal) {\n        const index = this.options.findIndex(op =>\n          this.isEqualOption(op, newVal)\n        );\n        this.onSelect(newVal, index);\n      }\n    }\n  },\n  methods: {\n    onSelect(option, index) {\n      if (option && !option[this.disabledProp]) {\n        this.selectedValue = option;\n        this.typeAheadPointer = index;\n        this.hideDropdown();\n        for(var i=0; i<this.options.length; i++){\n          if(option.value==this.options[i].value){\n              option=this.options[i];\n          }\n        }\n        if(option.value==null){\n          this.selectedValue = null;\n        }\n        else{\n          this.$emit(\"input\", option, option.valueProp, index);\n        }\n      } else if (option === null) {\n        this.selectedValue = null;\n      }\n    },\n    onEscape() {\n      this.hideDropdown();\n    },\n    typeAheadUp() {\n      if (!this.show) {\n        this.show = true;\n      }\n      if (this.typeAheadPointer > 0) {\n        const nextPointer = this.typeAheadPointer - 1;\n        const option = this.filteredOptions[nextPointer];\n        const isDisabled = option ? option[this.disabledProp] || false : false;\n        if (!isDisabled) {\n          this.typeAheadPointer--;\n        } else {\n          this.typeAheadPointer--;\n          this.typeAheadUp();\n        }\n      } else {\n        const nextEnabledOption = this.reversedOptions.findIndex(\n          o => o[this.disabledProp] !== true\n        );\n        this.typeAheadPointer = this.lastOptionIndex - nextEnabledOption;\n      }\n    },\n    typeAheadDown() {\n      if (!this.show) {\n        this.show = true;\n      }\n      if (this.typeAheadPointer < this.lastOptionIndex) {\n        const nextPointer = this.typeAheadPointer + 1;\n        const option = this.filteredOptions[nextPointer];\n        const isDisabled = option ? option[this.disabledProp] || false : false;\n        if (!isDisabled) {\n          this.typeAheadPointer++;\n        } else {\n          this.typeAheadPointer++;\n          this.typeAheadDown();\n        }\n      } else {\n        const nextEnabledOption = this.filteredOptions.findIndex(\n          o => o[this.disabledProp] !== true\n        );\n        this.typeAheadPointer = nextEnabledOption;\n      }\n    },\n    typeAheadSelect() {\n      if (this.filteredOptions[this.typeAheadPointer]) {\n        this.onSelect(\n          this.filteredOptions[this.typeAheadPointer],\n          this.typeAheadPointer\n        );\n      }\n    },\n    hideDropdown() {\n      this.show = false;\n      this.searchValue = \"\";\n    },\n    getOptionLabel(option) {\n      if (typeof option === \"object\") {\n        return option[this.textProp];\n      }\n      return option;\n    },\n    isSelectedOption(option, index) {\n      if (this.typeAheadPointer === -1 && this.selectedValue) {\n        return this.isEqualOption(option, this.selectedValue);\n      }\n      return this.typeAheadPointer === index;\n    },\n    isEqualOption(a, b) {\n      if (a && b && typeof a === \"object\" && typeof b === \"object\") {\n        return (\n          a[this.textProp] === b[this.textProp] &&\n          a[this.valueProp] === b[this.valueProp]\n        );\n      }\n      return a === b;\n    },\n    toggle() {\n      if (!this.disabled) {\n        this.show = !this.show;\n      }\n    }\n  }\n};\n</script>\n\n<style lang=\"scss\" scoped>\n* {\n  box-sizing: border-box;\n}\n\ninput {\n  width: 100%;\n}\n\nul {\n  font-size: 12px;\n  color: #424242;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  padding: 0px;\n  margin: 2px 0px 0px 0px;\n}\n\n.v-select {\n  position: relative;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .v-select-toggle {\n      background-color: #fff;\n      border-color: #f8f9fa;\n      opacity: 0.65;\n      cursor: not-allowed;\n\n\n      &:focus {\n        outline: 0 !important;\n      }\n    }\n  }\n}\n\n.v-select-toggle {\n  display: flex;\n  justify-content: space-between;\n  user-select: none;\n  padding: 0.375rem 0.75rem;\n  color: #212529;\n  background-color: #fff;\n  border-color: #d3d9df;\n  width: 100%;\n  text-align: right;\n  white-space: nowrap;\n  border: 1px solid #ccc;\n  padding: 0.375rem 0.75rem;\n  font-size: 12px;\n  font-family: inherit, sans-serif;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: background-color, border-color, box-shadow, 0.15s ease-in-out;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #e2e6ea;\n    border-color: #dae0e5;\n  }\n}\n\n.arrow-down {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  margin-top: 7px;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.v-dropdown-container {\n  position: absolute;\n  width: 100%;\n  background: red;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n}\n\n.v-dropdown-item {\n  text-decoration: none;\n  line-height: 25px;\n  padding: 0.5rem 1.25rem;\n  user-select: none;\n\n  &:hover:not(.default-option) {\n    background-color: #f8f9fa;\n  }\n\n  &.disabled {\n    color: #9a9b9b;\n  }\n\n  &.selected {\n    background-color: #007bff;\n    color: #fff;\n\n    &:hover {\n      background-color: #007bff;\n      color: #fff;\n    }\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    &:hover {\n      background-color: #fff;\n    }\n  }\n}\n\n.v-bs-searchbox {\n  padding: 4px 8px;\n\n  .form-control {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 13px;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n}\n</style>\n","* {\n  box-sizing: border-box;\n}\n\ninput {\n  width: 100%;\n}\n\nul {\n  font-size: 12px;\n  color: #424242;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  padding: 0px;\n  margin: 2px 0px 0px 0px;\n}\n\n.v-select {\n  position: relative;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n}\n.v-select.disabled {\n  cursor: not-allowed;\n}\n.v-select.disabled .v-select-toggle {\n  background-color: #fff;\n  border-color: #f8f9fa;\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n.v-select.disabled .v-select-toggle:focus {\n  outline: 0 !important;\n}\n\n.v-select-toggle {\n  display: flex;\n  justify-content: space-between;\n  user-select: none;\n  padding: 0.375rem 0.75rem;\n  color: #212529;\n  background-color: #fff;\n  border-color: #d3d9df;\n  width: 100%;\n  text-align: right;\n  white-space: nowrap;\n  border: 1px solid #ccc;\n  padding: 0.375rem 0.75rem;\n  font-size: 12px;\n  font-family: inherit, sans-serif;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n  transition: background-color, border-color, box-shadow, 0.15s ease-in-out;\n  cursor: pointer;\n}\n.v-select-toggle:hover {\n  background-color: #e2e6ea;\n  border-color: #dae0e5;\n}\n\n.arrow-down {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  margin-top: 7px;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.v-dropdown-container {\n  position: absolute;\n  width: 100%;\n  background: red;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  color: #212529;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n}\n\n.v-dropdown-item {\n  text-decoration: none;\n  line-height: 25px;\n  padding: 0.5rem 1.25rem;\n  user-select: none;\n}\n.v-dropdown-item:hover:not(.default-option) {\n  background-color: #f8f9fa;\n}\n.v-dropdown-item.disabled {\n  color: #9a9b9b;\n}\n.v-dropdown-item.selected {\n  background-color: #007bff;\n  color: #fff;\n}\n.v-dropdown-item.selected:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n.v-dropdown-item.disabled {\n  cursor: not-allowed;\n}\n.v-dropdown-item.disabled:hover {\n  background-color: #fff;\n}\n\n.v-bs-searchbox {\n  padding: 4px 8px;\n}\n.v-bs-searchbox .form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n/*# sourceMappingURL=vue-select-picker-bootstrap.vue.map */"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = "data-v-54036eab";
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Import vue component

// install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VueSelectPickerBootstrap', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// To auto-install when vue is found
/* global window global */
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
